import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */

const COURSE = 'course'
const TITLE = 'title'
const CONTACT_INFORMATION = 'contact_information'
const COURSE_DESCRIPTION = 'course_description'
const COURSE_PREREQUSITES = 'course_prerequisites'
const COURSE_INSTRUCTIONS = 'course_instructions'
const COURSE_MATERIALS = 'course_materials'
const STUDENT_PARTICIPATION = 'student_participation'
const HOMEWORK_POLICY = 'homework_policy'
const TUTORIAL_POLICY = 'tutorial_policy'
const ABSENTEE_POLICY = 'absentee_policy'
const TARDY_POLICY = 'tardy_policy'
const LATE_WORK_PROCEDURES = 'late_work_procedures'
const ABSENCE_PROCEDURES = 'absence_procedures'
const ASSIGNMENT_POLICY = 'assignment_policy'
const TURNING_IN_ASSIGNMENT = 'turning_in_assignment'
const RETAKE_POLICY = 'retake_policy'
const ASSESSMENT_TYPE = 'assessment_type'
const ASSESSMENT_CORRECTIONS = 'assessment_corrections'
const GRADING_POLICY = 'grading_policy'
const GRADING_BREAKDOWN = 'grading_breakdown'
const EXTRA_CREDITS = 'extra_credits'
const BEHAVIOUR_EXPECTATIONS = 'behaviour_expectations'
const CONSEQUENCES = 'consequences'
const BULLYING_PREVENTION = 'bullying_prevention'
const STUDENT_RESPONSIBILITIES = 'student_responsibilities'
const CLASSROOM_RULES = 'classroom_rules'
const PLAGIARISM = 'plagiarism'
const PENALTIES = 'penalties'
const SYLLABUS_EXPECTATIONS = 'syllabus_expectations'
const SYLLABUS_COMPONENTS = 'syllabus_components'

/**
 * Form model
 */
const formModel = () => {
  return {
    [TITLE]: {
      label: `${t('common.title')}`,
      name: TITLE,
      required: true,
    },
    [COURSE]: {
      label: `${t('common.course')}`,
      name: COURSE,
      required: true,
    },
    [CONTACT_INFORMATION]: {
      label: `${t('syllabuses.contact-information')}`,
      name: CONTACT_INFORMATION,
    },
    [COURSE_DESCRIPTION]: {
      label: `${t('syllabuses.course-description')}`,
      name: COURSE_DESCRIPTION,
    },
    [COURSE_PREREQUSITES]: {
      label: `${t('syllabuses.course-prerequisites')}`,
      name: COURSE_PREREQUSITES,
    },
    [COURSE_INSTRUCTIONS]: {
      label: `${t('syllabuses.course-instructions')}`,
      name: COURSE_INSTRUCTIONS,
    },
    [STUDENT_PARTICIPATION]: {
      label: `${t('syllabuses.student-participation')}`,
      name: STUDENT_PARTICIPATION,
    },
    [HOMEWORK_POLICY]: {
      label: `${t('syllabuses.homework-policy')}`,
      name: HOMEWORK_POLICY,
    },
    [TUTORIAL_POLICY]: {
      label: `${t('syllabuses.tutorial-policy')}`,
      name: TUTORIAL_POLICY,
    },
    [ABSENTEE_POLICY]: {
      label: `${t('syllabuses.absentee-policy')}`,
      name: ABSENTEE_POLICY,
    },
    [COURSE_MATERIALS]: {
      label: `${t('syllabuses.course-materials')}`,
      name: COURSE_MATERIALS,
    },
    [TARDY_POLICY]: {
      label: `${t('syllabuses.tardy-policy')}`,
      name: TARDY_POLICY,
    },
    [LATE_WORK_PROCEDURES]: {
      label: `${t('syllabuses.late-work-procedures')}`,
      name: LATE_WORK_PROCEDURES,
    },
    [ABSENCE_PROCEDURES]: {
      label: `${t('syllabuses.absence-procedures')}`,
      name: ABSENCE_PROCEDURES,
    },
    [ASSIGNMENT_POLICY]: {
      label: `${t('syllabuses.assignment-policy')}`,
      name: ASSIGNMENT_POLICY,
    },
    [TURNING_IN_ASSIGNMENT]: {
      label: `${t('syllabuses.turning-in-assignment')}`,
      name: TURNING_IN_ASSIGNMENT,
    },
    [RETAKE_POLICY]: {
      label: `${t('syllabuses.retake-policy')}`,
      name: RETAKE_POLICY,
    },
    [ASSESSMENT_TYPE]: {
      label: `${t('syllabuses.assessment-type')}`,
      name: ASSESSMENT_TYPE,
    },
    [ASSESSMENT_CORRECTIONS]: {
      label: `${t('syllabuses.assessment-corrections')}`,
      name: ASSESSMENT_CORRECTIONS,
    },
    [GRADING_POLICY]: {
      label: `${t('syllabuses.grading-policy')}`,
      name: GRADING_POLICY,
    },
    [GRADING_BREAKDOWN]: {
      label: `${t('syllabuses.grading-breakdown')}`,
      name: GRADING_BREAKDOWN,
    },
    [EXTRA_CREDITS]: {
      label: `${t('syllabuses.extra-credits')}`,
      name: EXTRA_CREDITS,
    },
    [BEHAVIOUR_EXPECTATIONS]: {
      label: `${t('syllabuses.behaviour-expectations')}`,
      name: BEHAVIOUR_EXPECTATIONS,
    },
    [CONSEQUENCES]: {
      label: `${t('syllabuses.consequences')}`,
      name: CONSEQUENCES,
    },

    [BULLYING_PREVENTION]: {
      label: `${t('syllabuses.bullying-prevention')}`,
      name: BULLYING_PREVENTION,
    },
    [STUDENT_RESPONSIBILITIES]: {
      label: `${t('syllabuses.student-responsibilities')}`,
      name: STUDENT_RESPONSIBILITIES,
    },
    [CLASSROOM_RULES]: {
      label: `${t('syllabuses.classroom-rules')}`,
      name: CLASSROOM_RULES,
    },
    [PLAGIARISM]: {
      label: `${t('syllabuses.plagiarism')}`,
      name: PLAGIARISM,
    },
    [PENALTIES]: {
      label: `${t('syllabuses.penalties')}`,
      name: PENALTIES,
    },
    [SYLLABUS_EXPECTATIONS]: {
      label: `${t('syllabuses.academic-expectations')}`,
      name: SYLLABUS_EXPECTATIONS,
    }, 
    [SYLLABUS_COMPONENTS]: {
      label: `${t('syllabuses.grading-plan')}`,
      name: SYLLABUS_COMPONENTS,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [COURSE]: null,
  [TITLE]: '',
  [CONTACT_INFORMATION]:  '',
  [COURSE_DESCRIPTION]: '',
  [COURSE_PREREQUSITES]: '',
  [COURSE_INSTRUCTIONS]: '',
  [COURSE_MATERIALS]: '',
  [STUDENT_PARTICIPATION]: '',
  [HOMEWORK_POLICY]: '',
  [TUTORIAL_POLICY]: '',
  [ABSENTEE_POLICY]: '',
  [TARDY_POLICY]: '',
  [LATE_WORK_PROCEDURES]: '',
  [ABSENCE_PROCEDURES]: '',
  [ASSIGNMENT_POLICY]: '',
  [TURNING_IN_ASSIGNMENT]: '',
  [RETAKE_POLICY]: '',
  [ASSESSMENT_TYPE]: '',
  [ASSESSMENT_CORRECTIONS]: '',
  [GRADING_POLICY]: '',
  [GRADING_BREAKDOWN]: '',
  [EXTRA_CREDITS]: '',
  [BEHAVIOUR_EXPECTATIONS]: '',
  [CONSEQUENCES]: '',
  [BULLYING_PREVENTION]: '',
  [STUDENT_RESPONSIBILITIES]: '',
  [CLASSROOM_RULES]: '',
  [PENALTIES]: '',
  [PLAGIARISM]: `${t('common.plagiarism-default')}`,
  [SYLLABUS_EXPECTATIONS]: [],
  [SYLLABUS_COMPONENTS]: []
}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [COURSE]: yup
    .object()
    .shape({
      title: yup
        .string()
        .nullable()
        .required(`${t('required-error-message')}`),
    })
    .nullable()
    .required(`${t('errors.required-error-message')}`),

    [TITLE]: yup
      .string()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
  })

export default formModel
